export default "__VITE_ASSET__DDPQADE4__"